export const CHANGED = 'Changed';
export const COMMITTED = 'Committed';
export const FINALIZED = 'Finalized';
